import { reportException } from "#skyward_error";
import { virtualDir } from "#skyward_global";
import { DEFAULT_CLOSE_BUTTON, showDialog } from "#skyward_modalLayer";
import { loadContent, notifyDOMLoad, registerLoadDOMCallback } from "#skyward_window";
import { clearValue, disable, enable, getOriginalValue, getValue, setValue } from "./skyward.ui.controls";
import { registerEvents } from "./skyward.ui.events";
import { getValue as getFilterOption } from "./skyward.ui.filterOptionSelector";
import { launchWorkflow } from "./skyward.ui.printScreen";
import { JQueryInput } from "./types";

const events =
{
    initDateRangeModeFoodService,
    initAssignmentSortMode,
    initDateRangeModeAssignment,
    initDateRangeMode,
    initSchoolYearRangeMode,
    initMissingAssignmentMode,
    printScheduleList,
    printAssignmentList,
    printAllAssignmentList: printAllAssignmentsStudentFamilyAccess
};

registerEvents("familyAccess", events);
registerLoadDOMCallback(init);
registerLoadDOMCallback(initFamilyAccessConfig);

function initDateRangeModeFoodService(this: JQueryInput)
{
    $(this).off('change.dateRangeModeFoodService').on('change.dateRangeModeFoodService', dateRangeModeFoodService);
}

function initAssignmentSortMode(this: JQueryInput)
{
    $(this).off('change.assignmentSortMode').on('change.assignmentSortMode', assignmentSortMode);
}

function initDateRangeModeAssignment(this: JQueryInput)
{
    $(this).off('change.dateRangeModeAssignment').on('change.dateRangeModeAssignment', dateRangeModeAssignment);
}

function initDateRangeMode(this: JQueryInput)
{
    $(this).off('change.dateRangeMode').on('change.dateRangeMode', dateRangeMode);
}

function initSchoolYearRangeMode(this: JQueryInput)
{
    $(this).off('change.schoolYearRangeMode').on('change.schoolYearRangeMode', schoolYearRangeMode);
}

function initMissingAssignmentMode(this: JQueryInput)
{
    $(this).off('change.missingAssignmentMode').on('change.missingAssignmentMode', missingAssignmentMode);
}

async function dateRangeMode(this: JQueryInput, event: JQuery.TriggeredEvent)
{
    const accessMode = $('#accessmode').val();
    const id = $(event.target as HTMLInputElement).attr("name")!;
    const postData: Record<string, string> = {};
    postData[id] = getFilterOption($(this))!;

    try
    {
        await $.ajax(
        {
            url: `${virtualDir}Grading/StudentSection/Set${id}${accessMode}`,
            type: "POST",
            dataType: "JSON",
            data: postData,
        });

        location.reload();
    }
    catch (e)
    {
        reportException(e);
    }
}

async function schoolYearRangeMode(this: JQueryInput)
{
    const accessMode = $('#accessmode').val();
    const selectedMode = getFilterOption($(this));

    const postData = { SchoolYearRangeMode: selectedMode };

    try
    {
        await $.ajax(
        {
            url: `${virtualDir}Grading/StudentSection/SetSchoolYearRangeMode${accessMode}`,
            type: "POST",
            dataType: "JSON",
            data: postData,
        });

        location.reload();
    }
    catch (e)
    {
        reportException(e);
    }
}

function foodServiceTabMode(this: JQueryInput)
{
    updateTabMode("FoodService", "Customer", $(this).text());
}

function gradingTabMode(this: JQueryInput)
{
    updateTabMode("Grading", "StudentSection", $(this).text());
}

function attendanceTabMode(this: JQueryInput)
{
    updateTabMode("Attendance", "StudentAttendance", $(this).text());
}

async function dateRangeModeAssignment(this: JQueryInput)
{
    const accessMode = $('#accessmode').val();
    const selectedMode = getFilterOption($(this));
    const postData = { DateRangeMode: selectedMode };

    try
    {
        await $.ajax(
        {
            url: `${virtualDir}Gradebook/StudentAssignment/SetDateRangeMode${accessMode}`,
            type: "POST",
            dataType: "JSON",
            data: postData,
        });

        location.reload();
    }
    catch (e)
    {
        reportException(e);
    }
}

async function dateRangeModeFoodService(this: JQueryInput)
{
    const accessMode = $('#accessmode').val();
    const selectedMode = getFilterOption($(this))!;
    const postData = { DateRangeMode: selectedMode };

    try
    {
        await $.ajax(
        {
            url: `${virtualDir}FoodService/Customer/SetDateRangeMode${accessMode}`,
            type: "POST",
            dataType: "JSON",
            data: postData,
        });

        location.reload();
    }
    catch (e)
    {
        reportException(e);
    }
}

async function missingAssignmentMode(this: JQueryInput)
{
    const element = $(this);
    let missingAssignmentToolbarData = element.parents('.missingAssignmentToolbar').data();
    if ((missingAssignmentToolbarData == null || $.isEmptyObject(missingAssignmentToolbarData)) && element.hasClass('missingAssignmentToolbar'))
    {
        missingAssignmentToolbarData = element.data();
    }
    let accessMode = missingAssignmentToolbarData.portal;
    if (accessMode == null)
    {
        accessMode = $("#accessmode").val();
    }
    let selectedMode = getFilterOption(element);
    if (selectedMode == null)
    {
        selectedMode = getValue(element);
    }
    //if selectedMoed is null we likely aren't using filter option, try just getting skyward.controls.getVaue
    const studentId = missingAssignmentToolbarData.studentId;
    const postData =
    {
        MissingAssignmentMode: selectedMode,
        StudentID: studentId
    };
    let actionPath;
    if (accessMode === 'TeacherAccess' || accessMode === 'TeacherTracker' || accessMode === 'Administrative' || accessMode === 'ActivitiesAccess' || accessMode === 'StudentServices')
    {
        const isStudentInfoPopup = missingAssignmentToolbarData.isstudentinfopopup === 'True';
        if (!isStudentInfoPopup && accessMode === 'Administrative')
        {
            actionPath = "Gradebook/ProgressReport/SetMissingAssignmentModeSelectedYear"
        }
        else if (isStudentInfoPopup && accessMode === 'TeacherAccess')
        {
            actionPath = "Gradebook/ProgressReport/SetMissingAssignmentModeTeacherAccessStudentInfoPopup"
        }
        else if (isStudentInfoPopup && accessMode === 'TeacherTracker')
        {
            actionPath = "Gradebook/ProgressReport/SetMissingAssignmentModeTeacherTrackerStudentInfoPopup"
        }
        else
        {
            actionPath = "Gradebook/ProgressReport/SetMissingAssignmentMode" + accessMode
        }
    }
    else
    {
        actionPath = "Grading/StudentSection/SetMissingAssignmentMode" + accessMode
    }

    try
    {
        await $.ajax(
        {
            url: virtualDir + actionPath,
            type: "POST",
            dataType: "JSON",
            data: postData
        });

        if (element.parents(".radioButtonGroup").first().hasClass("js-studentInfoPopup") ||
            element.hasClass("js-studentInfoPopup"))
        {
            const currentTab = element.parents(".informationPopup").first().find(".tabListItem.current");
            if (currentTab != null && currentTab.length > 0)
            {
                currentTab.removeClass("current");
                currentTab.trigger("click");
            }
        }
        else
        {
            location.reload();
        }
    }
    catch (e)
    {
        reportException(e);
    }
}

async function assignmentSortMode(this: JQueryInput)
{
    const element = $(this);
    const accessMode = $('#accessmode').val();
    const selectedMode = getFilterOption(element);
    const postData =
    {
        AssignmentSortMode: selectedMode,
    };
    const actionPath = `Gradebook/StudentAssignment/SetAssignmentSortMode${accessMode}`;

    try
    {
        await $.ajax(
        {
            url: virtualDir + actionPath,
            type: "POST",
            dataType: "JSON",
            data: postData,
        });

        location.reload();
    }
    catch (e)
    {
        reportException(e);
    }
}

function init(selector: JQueryInput)
{
    const btnGradingLegend = "#btnGradingLegend";
    $(btnGradingLegend).off('click', buildGradingLegendPopup).on('click', buildGradingLegendPopup);

    const element = $(selector);
    element.find(".FamilyAccessChangesPending").on('click', buildChangesPendingPopup);

    if (element.find("div.UserAccessProfileTile").length > 0)
    {
        element.find("#repeaterDiv").children("div.repeater").children("div.template").find("div.FamilyAccessStudentProfileTileRow").each(function ()
        {
            findMaxTileSize(this, "div.FamilyAccessStudentProfileTileFamilyInformation");
            findMaxTileSize(this, "div.FamilyAccessStudentProfileTileEmergencyContact");
        });
    }

    $('#StudentAssignments .js-tabbedContainerButton').off('click', assignmentTabMode).on('click', assignmentTabMode);
    $('.SkylertContactTabs .js-tabbedContainerButton').off('click', skylertTabMode).on('click', skylertTabMode);
    $('#CustomerTabbedContent .js-tabbedContainerButton').off('click', foodServiceTabMode).on('click', foodServiceTabMode);
    $('#StudentGradingTabs .js-tabbedContainerButton').off('click', gradingTabMode).on('click', gradingTabMode);
    $('#StudentAttendanceTabs .js-tabbedContainerButton').off('click', attendanceTabMode).on('click', attendanceTabMode);

    $('.familyStudentAccessDisciplineBrowses').each(function ()
    {
        const browse = $(this);
        $("body").on("browseLoaded." + browse.attr("id"), function (event)
        {
            const browse = event.target;
            notifyDOMLoad('#incidentoffensenamedetailwrapper');
            notifyDOMLoad($(browse).attr('id')!);
        });
    });

    if (element.find("p.studentIDCardBarcode").length > 0)
    {
        element.find("p.studentIDCardBarcode").each(function()
        {
            var barcodeLength = $(this).text()?.length;
            if (barcodeLength != null && barcodeLength != 0)
            {
                $(this).css("font-size", 'clamp(1rem, 60px, calc((min(440px, 100vw - 20px) - 32px) / ' + barcodeLength + ' * 2.344322344322344))');
                //this tries to use 60px as a default font size but scales down based on the minimum calculated screen space (max-width from .studentIDCardContainer vs (screen width - padding from .browseStaticHeight))
                //both further reduced by the padding from .studentIDCardBarcodeContainer
                //we then find the number of characters in the barcode and divide by the characters and apply a fixed aspect ratio for the barcode 39 font since font size conrols height, not width, but this is a monospace font.
            }
        });
    }
}

function findMaxTileSize(parent: JQueryInput, selector: string)
{
    let maxTileSize = 15;
    const tile = $(parent).find(selector);
    tile.each(function ()
    {
        const divHeight = $(this).height()!;
        if (divHeight > maxTileSize)
        {
            maxTileSize = divHeight;
        }
    });

    tile.height(maxTileSize);
}

function initFamilyAccessConfig(selector: JQueryInput)
{
    const element = $(selector);

    const checkbox = element.find('.familyConfigRetainCheckbox');
    const values = element.find('.familyConfigRetainTextbox');
    if (checkbox.length === 0 || values.length === 0)
    {
        return;
    }

    checkbox.on('change', function ()
    {
        const isChecked = checkbox.is(':checked');

        if (isChecked)
        {
            enable(values);

            values.each(function ()
            {
                const valueControl = $(this);
                const originalValue = getOriginalValue(valueControl);
                setValue(valueControl, originalValue);
            });
        }
        else
        {
            disable(values);
            clearValue(values);
        }
    });
    checkbox.trigger("change");
}

function updateTabMode(module: string, object: string, selectedMode: string)
{
    const accessMode = $('#accessmode').val();
    const postData = { UpdatedTabMode: selectedMode };

    $.ajax(
    {
        url: `${virtualDir}${module}/${object}/Set${module}TabMode${accessMode}`,
        type: "POST",
        dataType: "JSON",
        data: postData
    });
}

function printAllAssignmentsStudentFamilyAccess(this: JQueryInput)
{
    const parentContainer = $(this).parents("#StudentAssignmentWrapper");

    const accessMode = $('#accessmode').val();
    let postData: Record<string, string>;

    const guardianNameID = getValue(parentContainer.find("#GuardianNameID"));
    const guardianNameIDHash = getValue(parentContainer.find("#GuardianNameIDHash"));
    const selectedStudentMode = getValue(parentContainer.find("#SelectedStudentMode"));
    const studentID = getValue(parentContainer.find("#StudentID"));

    if (accessMode === "FamilyAccess")
    {
        postData =
        {
            "SelectedStudentMode": selectedStudentMode,
            "GuardianNameID": guardianNameID,
            "GuardianNameIDHash": guardianNameIDHash,
            "StudentID": studentID
        };
    }
    else
    {
        postData =
        {
            "StudentID": studentID
        };
    }

    const url = `${virtualDir}Gradebook/StudentAssignment/PrintAllAssignmentList${accessMode}`;
    launchWorkflow(url, postData);
}

function printAssignmentList(this: JQueryInput)
{
    const parentContainer = $(this).parents("#StudentAssignmentWrapper");

    const accessMode = $('#accessmode').val();
    const selectedMode = $('input[name=DateRangeModeAssignment]:checked').val() as string;
    let postData: Record<string, string>;

    const guardianNameID = getValue(parentContainer.find("#GuardianNameID"));
    const guardianNameIDHash = getValue(parentContainer.find("#GuardianNameIDHash"));
    const selectedStudentMode = getValue(parentContainer.find("#SelectedStudentMode"));
    const studentID = getValue(parentContainer.find("#StudentID"));

    if (accessMode === "FamilyAccess")
    {
        postData =
        {
            "SelectedStudentMode": selectedStudentMode,
            "GuardianNameID": guardianNameID,
            "GuardianNameIDHash": guardianNameIDHash,
            "DateRangeMode": selectedMode,
            "StudentID": studentID
        };
    }
    else
    {
        postData =
        {
            "DateRangeMode": selectedMode,
            "StudentID": studentID
        };
    }

    const url = `${virtualDir}Gradebook/StudentAssignment/PrintAssignmentList${accessMode}`;
    launchWorkflow(url, postData);
}

function assignmentTabMode(this: JQueryInput)
{
    const element = $(this);
    const accessMode = $('#accessmode').val();
    const selectedMode = $(this).text()[0];
    let studentEntityYearID = null;
    const browse = element.parent().siblings(".tabbedContent__allTabbedContents").find('.browse');

    if (browse != null)
    {
        studentEntityYearID = browse.attr('id')!.split('-')[1];
    }

    const postData =
    {
        AssignmentTabMode: selectedMode,
        StudentEntityYearID: studentEntityYearID
    };
    const actionPath = `Gradebook/StudentAssignment/SetAssignmentTabMode${accessMode}`;

    $.ajax(
    {
        url: virtualDir + actionPath,
        type: "POST",
        dataType: "JSON",
        data: postData
    });
}

function skylertTabMode(this: JQueryInput)
{
    const selectedMode = $(this).text()[0];
    const postData =
    {
        SkylertTabMode: selectedMode,
    };
    const actionPath = "Family/FamilyGuardian/SetSkylertTabModeFamilyAccess";

    $.ajax(
    {
        url: virtualDir + actionPath,
        type: "POST",
        dataType: "JSON",
        data: postData
    });
}

function printScheduleList(this: JQueryInput)
{
    const parentContainer = $(this).parents("#StudentScheduleDisplayWrapper");

    const accessMode = $('#accessmode').val();
    const selectedMode = $('input[name=DateRangeModechild]:checked').val() as string;
    let postData: Record<string, string>;

    const studentID = getValue(parentContainer.find("#StudentID"));
    const guardianNameID = getValue(parentContainer.find("#GuardianNameID"));
    const selectedStudentMode = getValue(parentContainer.find("#SelectedStudentMode"));

    if (accessMode === "FamilyAccess")
    {
        postData =
        {
            "SelectedStudentMode": selectedStudentMode,
            "GuardianNameID": guardianNameID,
            "DateRangeMode": selectedMode
        };
    }
    else
    {
        postData =
        {
            "DateRangeMode": selectedMode
        };
    }

    loadContent("popout", "Scheduling", "StudentScheduleDisplay", "PrintScheduleList" + accessMode, studentID, postData);
}

function buildGradingLegendPopup(this: JQueryInput)
{
    const clickedElement = $(this);
    const viewmode = clickedElement.data("viewmode");
    let screentype = clickedElement.data("screentype") as string;
    if (!screentype || screentype === undefined)
    {
        screentype = "";
    }
    const studentEntityYearIDsString = [""];
    const browse = $('#gradinglegendbrowse').val();

    let allGradeBrowsesID = ".browse[id^='" + browse + "-']";
    if ($(allGradeBrowsesID).length === 0)
    {
        allGradeBrowsesID = ".hiddenReportCardData[id^='" + browse + "-']";
    }
    $(allGradeBrowsesID).each(function ()
    {
        studentEntityYearIDsString[studentEntityYearIDsString.length] = $(this).attr('id')!.split('-')[1];
    });

    const schoolYearAndEntityIDsString: Record<string, string[]> = {};
    $('.historicSchoolYear').each(function ()
    {
        const schoolYearID = $(this).attr("data-schoolyearid")!;
        const entityID = $(this).attr("data-entityid")!;

        if (!(schoolYearID in schoolYearAndEntityIDsString))
        {
            schoolYearAndEntityIDsString[schoolYearID] = [entityID];
        }
        else
        {
            let entityInData = false;
            for (let i = 0; i < schoolYearAndEntityIDsString[schoolYearID].length; i++)
            {
                if (schoolYearAndEntityIDsString[schoolYearID][i] === entityID)
                {
                    entityInData = true;
                    break;
                }
            }

            if (!entityInData)
            {
                schoolYearAndEntityIDsString[schoolYearID].push(entityID);
            }
        }
    });

    const asyncPopup = $.ajax(
    {
        url: `${virtualDir}Grading/StudentSection/BuildGradingLegendPopup${screentype}${viewmode}/`,
        type: "POST",
        dataType: "viewparthtml",
        data:
        {
            studentEntityYearIDsString: JSON.stringify(studentEntityYearIDsString),
            schoolYearAndEntityIDsString: JSON.stringify(schoolYearAndEntityIDsString)
        }
    });

    clickedElement.off('click', buildGradingLegendPopup);

    showDialog("Grading Legend", asyncPopup, [DEFAULT_CLOSE_BUTTON], { anchorTo: clickedElement, beforeClose, titleTag: "h1" });

    function beforeClose()
    {
        clickedElement.off().on('click', buildGradingLegendPopup);
    }
}

function buildChangesPendingPopup(this: JQueryInput)
{
    const clickedElement = $(this);
    const viewmode = clickedElement.data("viewmode");
    const nameid = clickedElement.data("nameid");
    const entityid = clickedElement.data("entityid");
    const nameid_securityhash = clickedElement.data("nameid_securityhash");
    const entityid_securityhash = clickedElement.data("entityid_securityhash");

    const asyncPopup = $.ajax(
    {
        url: `${virtualDir}Family/StudentGuardian/BuildChangesPendingPopup${viewmode}/`,
        type: "POST",
        dataType: "viewparthtml",
        data: {
            NameID: nameid, EntityID: entityid,
            nameid_securityhash: nameid_securityhash,
            entityid_securityhash: entityid_securityhash
        }
    });

    clickedElement.off('click', buildChangesPendingPopup);

    showDialog("Pending Changes", asyncPopup, [DEFAULT_CLOSE_BUTTON], { anchorTo: clickedElement, beforeClose });

    function beforeClose()
    {
        clickedElement.off('click', buildChangesPendingPopup).on('click', buildChangesPendingPopup);
    }
}
